import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';

export const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    try {
      // Make the visitor anonymous again
      pendo.clearSession();
    } catch (error) {
      Sentry.captureException(error);
    }

    logout({
      returnTo: `${window.location.origin}/login`,
    });
  }, [logout]);

  return <></>;
};
